// extracted by mini-css-extract-plugin
export default {"search_hero":"SearchHero_search_hero__gE4Cl"};